<template>
    <div class="gofixInput gofixTextInput" v-bind:class="{gofixInputHasDesc:(desc || prefix === '$'), gofixInputError : (required && (!value && value !== 0) && blurInput),gofixInputDisable:disabled,gofixInputNoLabel:!label}">
        <div class="mainInput">
            <masked-input
                    type="text"
                    :value="(value || value === 0) ? value.toString() : null"
                    :mask="mask"
                    :guide="false"
                    :disabled="disabled"
                    :placeholder="placeholder"
                    placeholderChar="#"
                    v-on:keyup="handleInput"
                    @change="changeValueCallback"
                    v-on:blur="blurInput = true"
                    @focus.native="handleFocus"
                    v-bind:class="{hasValue:value || value === 0}"
            >
            </masked-input>
            <div class="label">{{label}}<span class="iconRequired" v-if="showIconRequired && required">*</span></div>
        </div>
        <p class="desc" v-if="desc || prefix === '$'" v-html="desc ? desc : (prefix === '$' ? '$0.00' : null)"></p>
        <slot name="gofixInput:text:after-desc"></slot>
    </div>
</template>

<script>
    import createNumberMask from 'text-mask-addons/dist/createNumberMask';
    export default {
        name: "money-input",
        props: {
            desc: {
                type: String,
                required: false,
                default: () => null
            },
            required: {
                type: Boolean,
                required: false,
                default: () => false
            },
            label: {
                type: String,
                required: false,
                default: () => "Label"
            },
            placeholder: {
                type: String,
                required: false,
                default: () => null
            },
            value: {
                default: () => null
            },
            prefix: {
                type:String,
                required: false,
                default: () => ""
            },
            thousandsSeparatorSymbol: {
                type:String,
                required: false,
                default: () => ","
            },
            suffix: {
                type:String,
                required: false,
                default: () => ""
            },
            integerLimit: {
                type:Number,
                required: false,
                default: () => 8
            },
            decimalLimit: {
                type:Number,
                required: false,
                default: () => 2
            },
            allowNegative: {
                type:Boolean,
                required: false,
                default: () => false
            },
            allowDecimal: {
                type:Boolean,
                required: false,
                default: () => true
            },
            includeThousandsSeparator: {
                type:Boolean,
                required: false,
                default: () => true
            },
            disabled: {
                type: Boolean,
                default: false
            },
            showIconRequired: {
                type: Boolean,
                required: false,
                default: () => false
            },

        },

        data() {
            return {
                blurInput:false,
                test:null,
                mask:createNumberMask({
                    prefix: this.prefix,
                    suffix: this.suffix,
                    allowDecimal: this.allowDecimal,
                    includeThousandsSeparator: this.includeThousandsSeparator,
                    thousandsSeparatorSymbol: this.thousandsSeparatorSymbol,
                    allowLeadingZeroes: true,
                    allowNegative: this.allowNegative,
                    integerLimit: this.integerLimit,
                    decimalLimit : this.decimalLimit
                })
            }
        },
        watch: {


        },
        created(){

        },
        methods: {
            handleInput (e) {
                this.$emit("input", e.target.value);
            },
            changeValueCallback(e){
                if(this.suffix === "%"){
                    /*let per = parseFloat(e.target.value);
                    if(per > 100){
                        this.$emit("input", "100.00%");
                        this.$emit("change", "100.00%");
                    }*/
                }else{
                    this.$emit("change", e.target._value);
                }

            },
            handleFocus (e) {
                this.$emit("focus", e.target.value);
            }
        }
    }
</script>

<style scoped>

</style>
